import * as types from '../constants/actionTypes';

const initialState = {
  // billPayments keyed by billId: { summary, payments }
  billPayments: {},
  // all payments list (for the main Payments page)
  allPayments: [],
  statistics: null,
  loading: false,
  actionLoading: false,
  error: null,
};

const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    // ── Create Payment ────────────────────────────────────────────────────────
    case types.CREATE_PAYMENT_REQUEST:
      return { ...state, actionLoading: true, error: null };

    case types.CREATE_PAYMENT_SUCCESS: {
      const payment = action.payload;
      const billId = payment?.bill_receipt_id;
      if (!billId) return { ...state, actionLoading: false };
      // Append new payment to cached bill entry if present; summary will be refreshed
      const existing = state.billPayments[billId];
      return {
        ...state,
        actionLoading: false,
        billPayments: existing
          ? {
              ...state.billPayments,
              [billId]: {
                ...existing,
                payments: [...(existing.payments || []), payment],
              },
            }
          : state.billPayments,
      };
    }

    case types.CREATE_PAYMENT_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    // ── Fetch Bill Payments (summary + list) ──────────────────────────────────
    case types.FETCH_BILL_PAYMENTS_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_BILL_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        billPayments: {
          ...state.billPayments,
          [action.payload.billId]: action.payload.data,
        },
      };

    case types.FETCH_BILL_PAYMENTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // ── Fetch Bill Payment Summary ────────────────────────────────────────────
    case types.FETCH_BILL_PAYMENT_SUMMARY_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_BILL_PAYMENT_SUMMARY_SUCCESS: {
      const { billId, data } = action.payload;
      const existing = state.billPayments[billId] || {};
      return {
        ...state,
        loading: false,
        billPayments: {
          ...state.billPayments,
          [billId]: { ...existing, summary: data },
        },
      };
    }

    case types.FETCH_BILL_PAYMENT_SUMMARY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // ── Fetch All Payments ────────────────────────────────────────────────────
    case types.FETCH_ALL_PAYMENTS_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_ALL_PAYMENTS_SUCCESS:
      return { ...state, loading: false, allPayments: action.payload };

    case types.FETCH_ALL_PAYMENTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // ── Payment Statistics ────────────────────────────────────────────────────
    case types.FETCH_PAYMENT_STATISTICS_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_PAYMENT_STATISTICS_SUCCESS:
      return { ...state, loading: false, statistics: action.payload };

    case types.FETCH_PAYMENT_STATISTICS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // ── Misc ──────────────────────────────────────────────────────────────────
    case types.CLEAR_PAYMENT_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
};

export default paymentReducer;
